import { defaults, flatten } from 'lodash'
import queue from 'queue'
import { trace } from 'lib/logging'

export async function asyncParallel<T, V>(
  array: T[] | undefined | null,
  iterator: (val: T, i: number) => Promise<V>,
  options: { concurrency?: number; timeout?: number } = {},
): Promise<V[]> {
  options = defaults(options, { concurrency: 10 })
  let results: V[] = []
  if (!array?.length) return results
  let q = queue({ autostart: true, results, ...options })
  array.forEach((item, i) => {
    q.push(async () => iterator(item, i))
  })
  let tid = setInterval(() => {
    trace(`parallel`, `asyncParallel q size`, q.length)
  }, 10000)
  return new Promise((resolve, reject) => {
    q.on(`end`, () => {
      clearInterval(tid)
      return resolve(flatten(results))
    })
    q.on(`error`, reject)
  })
}
